export default "__VITE_ASSET__458dd68c__"